import { render, staticRenderFns } from "./PodcastItemComponent.vue?vue&type=template&id=455c7122&scoped=true&"
import script from "./PodcastItemComponent.vue?vue&type=script&lang=js&"
export * from "./PodcastItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./PodcastItemComponent.vue?vue&type=style&index=0&id=455c7122&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c7122",
  null
  
)

export default component.exports